import * as React from 'react';

function SvgCheckmarkCircle(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5.204 6.649l-6.461 7.692a.77.77 0 01-.577.274h-.013a.77.77 0 01-.572-.254l-2.769-3.077a.769.769 0 111.143-1.03l2.178 2.42 5.893-7.015a.77.77 0 011.178.99z" })));
}

export default SvgCheckmarkCircle;
